import { configureStore } from '@reduxjs/toolkit';
import token from './modules/token';
import basic from './modules/basic';
import siteInfo from './modules/site-info';

export const store = configureStore({
    reducer: {
        token,
        siteInfo,
        basic
    }
})
